import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

// MODULES
 
// Dashboard
import dashboard from './modules/1_dashboard/dashboard'

// Publishing
import works from './modules/2_publishing/works'
import sheets from './modules/2_publishing/sheets'
import publishingProjects from './modules/2_publishing/publishingProjects'
import income from './modules/2_publishing/income'
import publishingStatements from './modules/2_publishing/publishingStatements'
import tracking from './modules/2_publishing/tracking'
import publishingStatistics from './modules/2_publishing/statistics'
import usage from './modules/2_publishing/usage'
import usageReview from './modules/2_publishing/usageReview'
import usageSettings from './modules/2_publishing/usageSettings'

//Label
import tracks from './modules/3_label/tracks'
import releases from './modules/3_label/releases'
import labelProjects from './modules/3_label/labelProjects'
import salesData from './modules/3_label/salesData'
import labelStatements from './modules/3_label/labelStatements'
import labelStatistics from './modules/3_label/statistics'

// ERP
import pricelists from './modules/4_erp/pricelists' 
import inventories from './modules/4_erp/inventories' 
import shipping from './modules/4_erp/shipping'
import invoices from './modules/4_erp/invoices'

// AZ
import azPersons from './modules/5_az/azPersons'
import azDistributors from './modules/5_az/azDistributors'
import azGroups from './modules/5_az/azGroups'
import azSocieties from './modules/5_az/azSocieties'
import azLive from './modules/5_az/azLive'

// Contracts
import publishingContracts from './modules/6_contracts/publishingContracts'
import labelContracts from './modules/6_contracts/labelContracts'

// Account
import credentials from './modules/7_account/credentials'
import companies from './modules/7_account/companies'
import settings from './modules/7_account/settings'
import modules from './modules/7_account/modules'
import mappings from './modules/7_account/mappings'

// Service Center
import insights from './modules/8_servicecenter/insights'

Vue.use(Vuex)

export const DEFAULT_PERSONS = {
    "id" : 0,
    "firstName": null,
    "lastName": null,
    "cellphone": null,
    "email": null, 
    "role": null,
    "keyName": null,
    "inheritFromGroup": 'yes'
}

export const CONFIRMATION_DIALOG = {
    "show": false,
    "result":  false,
    "resolveCallback":  null,
}

export const store = new Vuex.Store({
    // strict: true,
    state: {
      // Navigation menu
        drawer: false,
        openDriver: false,
      // General Application Data
        isLoggedIn: false,
        prevRoute: "/",
        loginTranslations: {
          'de': {
            'lang_LOGIN_BUTTON_CAPTION_LOGIN' : 'Anmelden',
            'lang_LOGIN_CAPTION_USERNAME'     : 'Benutzername',
            'lang_LOGIN_CAPTION_PASSWORD'     : 'Passwort'
          },
          'en': {
            'lang_LOGIN_BUTTON_CAPTION_LOGIN' : 'Login',
            'lang_LOGIN_CAPTION_USERNAME'     : 'Username',
            'lang_LOGIN_CAPTION_PASSWORD'     : 'Password'
          },
          'ja': {
            'lang_LOGIN_BUTTON_CAPTION_LOGIN' : '',
            'lang_LOGIN_CAPTION_USERNAME'     : '',
            'lang_LOGIN_CAPTION_PASSWORD'     : ''
          }
        },
      
      // General Data For Listpages
        isLoading: false,
        noDataText: 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND',
    
      // User-Object
        user: {
          // customerCompany: '',
          // customerNumber: '',
          // language: '',
          // username: '' ,
          // currency: '',
          // numberFormat: '',
          // homeSociety: '',
          // homeSocietyCode: null,
          // digitalDistribution: 'no',
        },
        selectedCurrency: null,
    
        // Paging
        totalRecords: 0,
        totalListed: 0,
        currentPage: 1,
        itemsPerPage: 100,
        numberOfPages: 0,

        // Searchdialog "paging"
        totalRecordsSearchDialog: 0,
        totalListedSearchDialog: 0,
    
        // Publishing & Label Companies (options & current selected)        
        publishingCompanies: [],
        labelCompanies: [],
        selectedOverAllCompany: {},
        selectedPublishingCompanyId: null,        
        selectedLabelCompanyId: null,
    
        // Dropdown options
        countries: {},
        azTypes: {},
        interests: [],
        apiConnections: {},
        dealflow: {},
        visibility: {},
        contractsRights:{},
        contractsApplyTo:{},
        accountCredentialsType:[],
        userInformation:{},
        generalLanguages: {},
        genres: {},
        languages: {},
        licensors: [],
        releaseGemaMediaTypes: [],
        releaseMediaTypes: [],
        societies: [],
        workStyles: {},
        publishingTypeOfRights: {},
        labelStatisticsInRows: {},
        publishingContractsTypes: [],
        instrumentations: [],
        
        // Dialogs , Snackbars, Alerts
        snackbar: {},
        selectionRequieredAlert: { show: false, txt: '' },
        showSelectionRequiredDialog: false,
        showPeriodRequiredDialog: false,
        showMediaFileUploadDialog:false,
        uploadPictureDialogText:'',
        selectionRequiredText: '',
        showDeletionDialog: false,
        deletionDialogContext: '',
        confirmationDialog: CONFIRMATION_DIALOG,
        // showDeletionDialogProlists: false,
        // showDeletionDialogMyMapping: false,
        showFileBulkImportDialog: false,
        showGemaWorksCheckDialog: false,
        showSearchDialog: false,
        errorDialogMessage: null,
        showConnectArtistDialog: false,
        showStatementPreviewDialog:false,

        // Error Dialog
        showErrorDialog: false,
        errorMessageCode: null,
        errorDialogCsvLink: '',
        
        // File Import Dialog
        selectedFileImportOption: [],
        selectedFileImport: [],
        selectedPeriodValuesImportDialog: {
          num: null,
          period: 'notDefined',
          year: null
        },    
        selectedImportDialogCheckboxes: ["runErrorLists"],

        //Report Button Option
        selectedFileReport:[],

        // Run Error List Dialog
        showRunErrorListDialog: false,
        runErrorListDialogText: "",
        runErrorListDialogProgressValue: 0,
        runErrorListDialogPolling: null,

        // Inline Editing Dialog (Listpage)
        showInlineEditingDialog: false,

        // Regions Dialog
        showRegionDialog: false,
        regionDialogIncludeOptions: [],
        regionDialogExcludeOptions: [],
        regionDialogDetailsInclude: [],
        regionDialogDetailsExclude: [],

        // Editing Dialog
        showEditingDialog: false,
        editingDialogHeadline: '',

        // Manage Tags Dialog
        showManageTagsDialog: false,
        addTag: '',
        removeTag: '',
        // Manage Sync Data Dialog
        showSyncDataDialog: false,

        //Move into company dialog
        showMoveContractsDialog:false,

        // Persons Dialog
        personsPanelEntry: [],
        selectedPersonsPanelEntry: [],
        personsPanelEntryEditingDialogDetails: DEFAULT_PERSONS,
        defaultPersonsPanelEntry: DEFAULT_PERSONS,
        personsPanelEntryPersonOptions: [],
        selectedPersonPersonsPanelDialog: null,

        // Digital Platforms
        digitalPlatforms: [],
    
        // File Uploader props
        selectedFileBulkImport: [], // OPTION
        selectedFileRecordsBulkImport: [], // v-model for VueFileAgent
        selectedFileReportDataBulkImport: [], // report array for report table
        selectedFileBulkImportUploader: true, // control var for VueFileAgent component
        fileBulkUploaderFileRecordsForUpload: [], // used by VueFileAgent for selected files
        selectedImageUploadFile:null,

        //DragAndDrop Uploader 
        showDragAndDropUploader:true,
        showUploadBtnDragAndDropUploader:false,
        imageUploaderImageExists:false,
        showImageUploadDialog:false,
        imageUploaderContext: '',

        //ImageUploadOnly (Those above are with cropper and change image)
        showImageUploadOnlyDialog:false,

        //Drag&&Drop Media Uploader
        selectedMediaUploadFiles:[],
        
        fileBulkUploaderUploadUrl: [],
        fileBulkUploaderUploadHeaders: {},
        fileBulkUploaderDeletable: true,
        fileBulkUploaderReadonly: false,
        fileBulkUploaderDetailsTag: "",
        fileBulkUploaderDetailsSelectedLabelId: null,
        fileBulkUploaderLabelsDropdown: [],
        
        selectedFileUploadOption: [],
        showFileImportDialog: false,
        importDialogText: '',
        uploadProgressbarValue: 0,
        // General Period Filter Component
        balanceInNumbersSelected: [],
        balanceInTimeUnitSelected: [],
        balanceInYearSelected: [],
    
        // Global audio file property
        audio: null,

        // Importers for Listpages
        listpageImporters: [],
        
        // Data sharing dialog
        showDataSharingDialog: false,
      },
    getters, mutations, actions,

    modules:  {
      // Dashboard
        dashboard,
      // Publishing 
        works, sheets, publishingProjects, income, publishingStatements, tracking, publishingStatistics, usage, usageReview, usageSettings,
      // Label
        tracks, releases, labelProjects, salesData, labelStatements,labelStatistics,
      // ERP
        pricelists, inventories, shipping, invoices,
      // AZ
        azPersons, azDistributors, azGroups, azSocieties, azLive,
      // Contracts
        publishingContracts, labelContracts,
      // Account,
        credentials, companies, settings, modules, mappings,
      // Service Center
        insights,
    }
})

export default store